import CircularProgress from '@mui/material/CircularProgress';

export default function Circularprogress() {
    return (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "60vh" }}><CircularProgress /></div>
       
    )
}
